import React, { useEffect, useState } from 'react';
import { getResourceBySlug } from '../../lib/db';
import { SparklesIcon } from '@heroicons/react/24/solid';

const RESOURCE_ICONS = {
  article: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/article-icon.png',
  video: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/video-icon.png',
  template: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/template-icon.png',
  guide: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/guide-icon.png',
  tool: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/tool-icon.png',
  default: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/resource-icon.png'
};

const PlaybookCallout = ({ 
  type = 'default',
  icon,
  title,
  href,
  description,
  bgColor,
  className = '',
  resourceSlug,
  badge,
  intro
}) => {
  const [resource, setResource] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchResource = async () => {
      if (resourceSlug) {
        setLoading(true);
        try {
          const data = await getResourceBySlug(resourceSlug);
          setResource(data);
        } catch (error) {
          console.error('Error fetching resource:', error);
        }
        setLoading(false);
      }
    };

    fetchResource();
  }, [resourceSlug]);

  const resolvedIcon = icon || (resource?.banner_url) || RESOURCE_ICONS[type] || RESOURCE_ICONS.default;
  const displayTitle = resource?.title || title;
  const displayDescription = resource?.description || description;
  const displayHref = (resourceSlug && resource?.slug) ? `/playbooks/${resource.slug}/key-info` : (resource?.url || href || '');
  const isInternal = typeof displayHref === 'string' && displayHref.startsWith('/');

  return (
    <a
      href={displayHref}
      target={isInternal ? undefined : '_blank'}
      rel={isInternal ? undefined : 'noopener noreferrer'}
      className={`flex flex-col px-7 py-7 rounded-xl border-2 border-primary-light font-semibold transition shadow-md hover:shadow-lg hover:bg-primary-light/10 ${bgColor || 'bg-gray-900/60'} ${className}`}
      style={{ textDecoration: 'none' }}
    >
      {(badge || intro) && (
        <div className="mb-3">
          {badge && (
            <span className="flex items-center text-primary-light text-xs font-semibold uppercase tracking-wide mb-1">
              <SparklesIcon className="h-4 w-4 mr-2 text-primary-light" />
              {badge}
            </span>
          )}
          {intro && (
            <div className="text-gray-300 text-sm mt-1">{intro}</div>
          )}
        </div>
      )}
      <div className="flex flex-row items-center min-h-[10rem] md:min-h-[12rem] w-full">
        <img
          src={resolvedIcon}
          alt={`${type} icon`}
          className="h-40 w-40 md:h-44 md:w-44 rounded-lg mr-8 object-cover shadow-md bg-gray-800 flex-shrink-0"
          style={{ background: '#23272f' }}
        />
        <div className="flex-1 min-w-0 flex flex-col justify-center">
          <div className="text-primary-light text-xl font-bold mb-1 truncate">{displayTitle}</div>
          {displayDescription && <div className="text-gray-300 text-base leading-snug line-clamp-3">{displayDescription}</div>}
        </div>
        <div className="flex items-center h-full">
          <svg className="h-12 w-12 ml-8 text-primary-light flex-shrink-0" style={{minHeight: '3rem'}} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </div>
      </div>
    </a>
  );
};

export default PlaybookCallout;